<script setup lang="ts">
import { useConfirmDialog } from '@vueuse/core'
import UiButton from '@/components/ui/button/Button.vue'
import UiPanel from '@/components/shared/UiPanel.vue'
import UiPanelWrapper from '@/components/shared/UiPanelWrapper.vue'

const { isRevealed, reveal, confirm, cancel } = useConfirmDialog()

defineExpose({
  confirm: reveal
})
</script>

<template>
  <ui-panel-wrapper v-if="isRevealed" :open="isRevealed" modal>
    <ui-panel :title="$t('CustomDrills.label.DeleteDrill')" class="w-[95vw]" @close="cancel">
      <p class="text-center">{{ $t('CustomDrills.label.DeleteDrillMsg') }}</p>
      <div class="flex flex-col gap-2 sm:flex-row">
        <ui-button type="button" variant="default2" size="lg" class="w-full" @click="confirm">
          {{ $t('CustomDrills.button.DeleteDrill') }}
        </ui-button>
        <ui-button
          type="button"
          variant="secondary2"
          size="lg"
          class="w-full text-white"
          @click="cancel"
        >
          {{ $t('CustomDrills.button.Cancel') }}
        </ui-button>
      </div>
    </ui-panel>
  </ui-panel-wrapper>
</template>

<style scoped></style>
